export default "__VITE_ASSET__CCC7eUct__"